
import styles from "./ediror.module.scss";
import { HandySvg } from "handy-svg";
import { useEffect, useRef, useState } from "react";
import { getTempplates } from "../../../pages/api/sportcards";

const TemplateBtn = ({ template, sportCardsState, setSportCardsState, templateUniqClass }) => {
  const btnRef = useRef(null)
  const [chenge, setChange] = useState(true)

  useEffect(() => {
    const handleResize = () => {
      setChange(true)
      setTimeout(() => {
        if (btnRef.current === null) return;
        let scale = btnRef.current.offsetWidth / 600;

        const card = btnRef.current.querySelector(".card")

        if (btnRef.current.offsetHeight < (836 * scale)) {
          scale = btnRef.current.offsetHeight / 1000
        }

        card.style.transform = `scale(${scale})`;

        setChange(false)
      }, 1000)

    }


    window.addEventListener("resize", handleResize)

    handleResize()

    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return <button ref={btnRef} key={template.id} onClick={() => setSportCardsState({ ...sportCardsState, template: template })} className={`${styles.template} ${template.id === sportCardsState.template?.id ? styles.active : ""} ${templateUniqClass} ${chenge ? styles.chenge : ""}`} dangerouslySetInnerHTML={{ __html: template.html }} />
}

const Template = ({ sportCardsState, setSportCardsState, setSteps }) => {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    const getTempplatesList = async (token) => {
      const response = await getTempplates(token);
      setTemplates(response.data);
    }
    getTempplatesList()
  }, [])

  const Next = () => {
    setSteps(prev => prev.map(step => step.name === "Pose" ? { ...step, active: true } : { ...step, active: false }));
  }

  return (
    <>
      <div className={styles.templatesWrapeer}>
        {templates.map((template, index) => {
          const templateUniqClass = `template${index}`

          return (
            <>
              <style dangerouslySetInnerHTML={{ __html: template.css.replace(/\.(?=[a-zA-Z][\w-]*\s*{)/g, `.${templateUniqClass} .`) }} />
              <TemplateBtn key={template.id} template={template} sportCardsState={sportCardsState} setSportCardsState={setSportCardsState} templateUniqClass={templateUniqClass} />
            </>
          )
        })}
      </div>
      <button onClick={Next} disabled={sportCardsState.template === null} className={styles.nextBtn}>Next <HandySvg src={"/illustration_service/next.svg"} width={24} height={24} fill={"transparent"} /></button>
    </>

  )
}

export default Template